import ViewLocalAdmin from './ViewLocalAdmin';

export default ViewLocalAdmin;
